import subscriptionsReducer from "./redux-oidc/subscriptions";
import { injectReducer } from "./rootReducer";
const injectReducers = (store) => {
  injectReducer(store, { key: "subscriptions", reducer: subscriptionsReducer });
};

export default injectReducers;
